<script setup lang="ts">
import { computed, onBeforeMount } from 'vue';
import { NConfigProvider, darkTheme } from 'naive-ui';
import { localStg } from '@/utils/storage';
import { useAppStore } from '@/store/modules/app';
import { useThemeStore } from './store/modules/theme';
import { naiveDateLocales, naiveLocales } from './locales/naive';
const appStore = useAppStore();
const isLogin = Boolean(localStg.get('token'));

defineOptions({
  name: 'App'
});

const themeStore = useThemeStore();

const naiveDarkTheme = computed(() => (themeStore.darkMode ? darkTheme : undefined));

const naiveLocale = computed(() => {
  return naiveLocales[appStore.locale];
});

const naiveDateLocale = computed(() => {
  return naiveDateLocales[appStore.locale];
});
onBeforeMount(async () => {
  if (isLogin) {
    await appStore.updateLocalString();
  }
});
</script>

<template>
  <NConfigProvider
    :theme="naiveDarkTheme"
    :theme-overrides="themeStore.naiveTheme"
    :locale="naiveLocale"
    :date-locale="naiveDateLocale"
    class="h-full"
  >
    <AppProvider>
      <RouterView class="custom-bgc" />
    </AppProvider>
  </NConfigProvider>
</template>
